import React, { useEffect, useRef } from 'react';

import { WorkId } from 'js/liswp/types';
import showModal from 'js/components/show_modal';
import { ShareWorkModal } from 'js/liswp/share_work.wjs';
import NotInterestedModal from 'js/canonical_cards/work_card/modals/not_interested_modal';
import ReportModal from '../modals/report_modal';
import AddPaperToWorkCollectionModal from 'js/library/react/add_paper_to_work_collection_modal.wjs';
import { WorkCardWork } from '../types';

interface AddToWorkCollectionModalProps {
  startAddingItemToCollection?: () => void;
  workCollectionsWithWorks?: Record<
    string,
    {
      id: number;
      name: string;
      work_count?: number;
      works?: any[]; // Replace `any[]` with the specific type if known
    }
  >;
}

interface MoreActionsPopoverProps {
  work: WorkCardWork;
  reportWork: () => void;
  loadWorkShareSuggestions: (workId: WorkId) => void;
  closeMe: (e: MouseEvent | Event) => void;
  showFewerButton?: boolean;
  enableAddToWorkCollection?: boolean;
  addToWorkCollectionModalProps?: AddToWorkCollectionModalProps;
}

const MoreActionsPopover: React.FC<MoreActionsPopoverProps> = ({
  work,
  reportWork,
  loadWorkShareSuggestions,
  closeMe,
  showFewerButton = false,
  enableAddToWorkCollection = false,
  addToWorkCollectionModalProps = {},
}) => {
  const wrapperRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (
      work.shareSuggestions == null ||
      Object.values(work.shareSuggestions).length === 0
    ) {
      loadWorkShareSuggestions(work.id);
    }

    const handleClickOutside = (e: MouseEvent) => {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(e.target as Node)
      ) {
        closeMe(e);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [work, loadWorkShareSuggestions, closeMe]);

  const onAddToListClick = () => {
    showModal(AddPaperToWorkCollectionModal, {
      workId: work.id,
      workTitle: $h.truncate(work.title, 50),
      ...addToWorkCollectionModalProps,
    });
  };

  const onShareClick = () => {
    const props = {
      initialSuggestions: work.shareSuggestions || [],
      alreadyShared: work.alreadySharedUserIds || [],
      workId: work.id,
      workTitle: work.title,
      workUrl: work.internalUrl,
      collectionName: 'shares_news_feed_work_card',
      source: 'news_feed_share',
      // @ts-ignore jquery
      hideModal: () => $('.modal').modal('hide'),
    };
    showModal(ShareWorkModal, props);
  };

  const onShowFewerClick = () => {
    const props = {
      reportWork: reportWork,
      workId: work.id,
    };
    showModal(NotInterestedModal, props, {
      disableModalContentClass: true,
    });
  };

  const onReportClick = () => {
    const props = {
      reportWork: reportWork,
      workId: work.id,
    };
    showModal(ReportModal, props, {
      disableModalContentClass: true,
    });
  };

  return (
    <div className="work-card--more-actions-popover" ref={wrapperRef}>
      {enableAddToWorkCollection && (
        <div
          className="work-card--more-actions-popover-row"
          onClick={onAddToListClick}
        >
          <span className="fa fa-plus work-card--more-actions-popover-icon" />
          <div>Add to List</div>
        </div>
      )}
      <div
        className="work-card--more-actions-popover-row"
        onClick={onShareClick}
      >
        <span className="fa fa-share work-card--more-actions-popover-icon" />
        <div>Share paper</div>
      </div>
      {showFewerButton && (
        <div
          className="work-card--more-actions-popover-row"
          onClick={onShowFewerClick}
        >
          <span className="fa fa-ban work-card--more-actions-popover-icon" />
          <div>Show me fewer like this</div>
        </div>
      )}
      <div
        className="work-card--more-actions-popover-row"
        onClick={onReportClick}
      >
        <span className="fa fa-flag work-card--more-actions-popover-icon" />
        <div>Report</div>
      </div>
    </div>
  );
};

export default MoreActionsPopover;
